import { StateUtils } from '@spartacus/core';
import { CuttingTemplate } from '../../../../../core/model';
import { CartEntryCuttingActionTypes } from '../actions/cart-entry-cutting.action';
import { CartActions } from '../actions/index';

export const initialState: CuttingTemplate = undefined;

export function reducer(
  state = initialState,
  action: CartActions.CartEntryCuttingActions | StateUtils.LoaderAction
): CuttingTemplate {
  switch (action.type) {
    case CartEntryCuttingActionTypes.CalculateCuttingTemplateFail: {
      return initialState;
    }
    case CartEntryCuttingActionTypes.CalculateCuttingTemplateSuccess: {
      return action.payload ? action.payload.result : initialState;
    }
  }
  return state;
}
